import PropTypes from "prop-types";

import Button from "@shared/v2/Button";

import { useLocalStorage } from "@shared/hookHelpers";
import { useCurrentUser } from "../../reducers/layoutReducer/selectors";

const SmsComplianceNotice = ({ className }) => {

  const currentUser = useCurrentUser();

  const [usersSmsComplianceNotice, setUsersSmsComplianceNotice] = useLocalStorage("usersSmsComplianceNotice", []);

  if (usersSmsComplianceNotice.includes(currentUser.id)) {
    return null;
  }

  return (
    <div className={`tw-border-1px tw-border-solid tw-border-[#FAE4C3] tw-bg-[#FAF1E6] tw-rounded-[4px] tw-flex tw-gap-[16px] tw-items-center tw-py-[12px] tw-px-[16px] ${className}`}>
      <div className="tw-text-[#AD6714] tw-text-14d tw-flex tw-flex-col tw-gap-[4px]">
        <b>SMS Compliance & Sending Mass Texts</b>
        <div className="">Phone carriers have daily limits for sending texts. Exceeding send limits risks your number being flagged, especially if the content violates SMS compliance. Please consider this when setting up Auto Plan steps (texts) and triggers.</div>
      </div>
      <Button schema='semantic-yellow' className='tw-shrink-0' onClick={() => {
        setUsersSmsComplianceNotice([...usersSmsComplianceNotice, currentUser.id]);
      }}>
        I understand
      </Button>
    </div>
  )
};

export default SmsComplianceNotice;

SmsComplianceNotice.propTypes = {
  className: PropTypes.string,
}

SmsComplianceNotice.defaultProps = {
  className: "",
}